<template>
    <div>
        <div
            v-if="showChat"
            class="chat-bg"
        >
            <div
                :class="`chat-mod-${modelo}`"
                class="chat col-lg-5 col-md-5 col-sm-12"
            >
                <div class="chat-header">
                    <div class="chat-title">
                        <div class="chat-close" @click="closeChat">
                            <i class="fas fa-times-circle"></i>
                        </div>
                    </div>
                    <div class="chat-subtitle" :style="`background-color: ${config.color};`">
                        <div
                            class="chat-avatar"
                            :style="`background-image: url(${config.operatorAvatarUrl})`"
                        ></div>
                        <div class="chat-info">
                            <h4 class="chat-info-name mb-0">{{config.operatorName}}</h4>
                            <p class="chat-info-status mb-0 font-weight-normal">
                                <span v-if="isTyping">Está digitando...</span>
                                <span v-else>Online agora</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="chat-body">
                    <ul>
                        <li
                            v-for="(msg, index) in messages"
                            :key="index"
                            :class="{'chat-left': msg.from === 'operator', 'chat-right': msg.from === 'user'}"
                        >
                            <div class="chat-body-autor">
                                <span v-if="msg.from === 'operator'">{{config.operatorName}}</span>
                                <span v-else-if="msg.from === 'user'">{{config.userName}}</span>
                            </div>
                            <div class="chat-body-message" :style="`background-color: ${config.color};`">
                                {{msg.message}}
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="chat-status">
                    <span v-if="isTyping">...</span>
                </div>
                <div class="chat-footer">
                    <the-mask
                        v-if="inputMask.length > 0"
                        ref="inputMasked"
                        :type="inputType"
                        :placeholder="inputPlaceholder"
                        :disabled="!inputEnabled"
                        :mask="inputMask.slice()"
                        v-model="inputValue"
                        masked
                        class="masked"
                        @keyup.enter="response"
                    />
                    <input
                        v-if="inputMask.length === 0"
                        ref="inputUnmasked"
                        :type="inputType"
                        :placeholder="inputPlaceholder"
                        :disabled="!inputEnabled"
                        v-model="inputValue"
                        class="unmasked"
                        @keyup.enter="response"
                    />
                    <div
                        class="chat-send"
                        @click="response"
                        :style="`color: ${config.color};`"
                    >
                        <i class='fa fa-paper-plane'></i>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="showFabChat && !showChat"
            :style="`background-image: url(${config.operatorAvatarUrl});`"
            class="fabChat"
            @click="openChat"
        ></div>
        <div
            v-if="showWraperLoader && !showChat"
            class="wrap-loader"
        >
            <div class="loader"></div>
        </div>
        <div
            v-if="showFabMessage"
            class="fabMsg"
            @click="openChat"
            v-html="config.greeting"
        ></div>
    </div>
</template>

<script>
export default {
    name: "ChatBot",
    props: {
        property: {
            type: String,
            default: null
        },
        uri: {
            type: String,
        },
        avatar: {
            type: String,
        },
    },
    data() {
        return {
            showChat: false,
            showFabChat: false,
            showWraperLoader: false,
            showFabMessage: false,
            isTyping: false,
            modelo: 2,
            step: -1,
            inputType: "text",
            inputMask: [],
            inputPlaceholder: null,
            inputEnabled: false,
            messages: [],
            inputValue: "",
            lead: {
                id: null,
                reference: null,
                name: null,
                email: null,
                phone: null,
                message: null,
            },
            config: {
                enabled: true,
                userName: "Você",
                operatorName: "Helena",
                operatorAvatarUrl: "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y",
                color: "#1abc9c",
                greeting: "Olá, vamos conversar sobre esse imóvel?",
                goodbye: "Obrigado {name}. Logo mais entraremos em contato.",
                interval: 5,
                questions: [
                    {
                        label: "Telefone",
                        type: "text",
                        text: "{greeting}, me passa o seu Whatsapp, por favor? " +
                            "Assim podemos continuar a conversa por lá se a conexão cair.",
                        mask: ['(##) ####-####', '(##) #####-####'],
                        placeholder: "(00) 00000-0000",
                        regex: "(?:\\()[0-9]{2}(?:\\))\\s?[0-9]{4,5}(?:-)[0-9]{4}",
                        field: "phone",
                    },
                    {
                        label: "Nome",
                        text: "Perfeito, como posso te chamar?",
                        placeholder: "Digite seu nome",
                        regex: "([A-z]{1,}([\\.,] |[-']| )?)+[A-z]+\\.?",
                        field: "name",
                    },
                    {
                        label: "Email",
                        type: "email",
                        text: "Me passa também seu email, aí esse imóvel fica registrado na sua caixa de entrada.",
                        mask: null,
                        placeholder: "Digite seu e-mail",
                        // eslint-disable-next-line max-len
                        regex: "(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))",
                        field: "email",
                    },
                ],
            },
        }
    },
    computed: {
        greeting() {
            const hour = new Date().getHours();
            if (hour >= 0 && hour < 12) {
                return "Bom dia";
            } else if (hour >= 12 && hour < 18) {
                return "Boa tarde";
            } else {
                return "Boa noite";
            }
        },
    },
    created() {
        this.lead.reference = this.property;
        this.config.operatorAvatarUrl = this.avatar;
    },
    async mounted() {
        await this.loadConfig();
        await this.init();
    },
    methods: {
        async loadConfig() {
            const config = await axios.get(this.uri)
                .then(response => response.data)
                .catch(error => console.log(error));

            this.config = Object.assign(this.config, config);
        },
        async init() {
            if (!this.config.enabled) return;
            await this.delay(this.config.interval * 1000);
            this.showFabChat = true;

            await this.delay(700);
            this.showWraperLoader = true;

            await this.delay(2000);
            this.showWraperLoader = false;
            this.showFabMessage = true;
        },
        async openChat() {
            this.showFabMessage = false;
            this.showChat = true;

            if (this.step === -1) {
                await this.interaction();
            }
        },
        closeChat() {
            this.showChat = false;
        },
        async interaction() {
            this.step++;

            this.inputMask = [];
            this.inputType = "text";
            this.inputPlaceholder = null;
            await this.typing();

            if (this.step === this.config.questions.length) {
                this.messages.push({
                    from: 'operator',
                    message: this.template(this.config.goodbye),
                });
                return;
            }

            const question = this.config.questions[this.step];

            this.messages.push({
                from: 'operator',
                message: this.template(question.text),
            });
            this.inputMask = question.mask ?? [];
            this.inputType = question.type ?? "text";
            this.inputPlaceholder = question.placeholder ?? null;
            this.inputEnabled = true;

            setTimeout(() => {
                this.$refs.inputUnmasked?.focus();
            }, 100);
        },
        async typing() {
            this.isTyping = true;
            await this.delay(Math.random() * 5000);
            this.isTyping = false;
        },
        async response() {
            if (!this.inputEnabled) return;

            const message = this.inputValue;
            this.inputEnabled = false;
            this.messages.push({
                from: 'user',
                message,
            });
            this.inputValue = "";

            this.isTyping = true;
            if (this.config.questions[this.step].regex ?? null) {
                const regex = new RegExp(this.config.questions[this.step].regex);
                if (!regex.test(message)) {
                    await this.delay(Math.random() * 1000);
                    this.inputEnabled = true;
                    this.messages.push({
                        from: 'operator',
                        message: "Ops! Não entendi. Pode digitar novamente?"
                    });
                    this.isTyping = false;
                    return;
                }
            }

            if (this.config.questions[this.step].field ?? null) {
                this.lead[this.config.questions[this.step].field] = message;
                if (this.config.questions[this.step].field === 'name') {
                    this.config.userName = message;
                }
            }

            this.isTyping = true;
            axios.post(this.uri, this.lead).then(({data}) => {
                this.lead.id = data.id;
                this.interaction();
            });
        },
        template(message) {
            return message.replace(/{([^{}]+)}/g, (match, key) => {
                return this.lead[key] || this[key] || match;
            });
        },
        async delay(ms) {
            return await new Promise(resolve => setTimeout(resolve, ms));
        },
    },
}
</script>

<style scoped>

</style>
